/**
 * Горизонтальная полоса этапов таймлайна.
 *
 * Показывает все приёмы плана как шаги: завершённые — с галочкой,
 * текущий — с номером и меткой «сейчас», будущие — номером.
 * Полоса под шагом отражает долю выполненных услуг этапа.
 */
import React from "react";
import { IoCheckmarkOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { formatRange } from "./planTimelineData";

const progressPercent = (stage) =>
    stage.total > 0 ? Math.round((stage.done / stage.total) * 100) : 0;

function PatientPlanTimelineStepper({ stages = [], active = 0, onSelect }) {
    const { t } = useTranslation("patient");

    return (
        <div className="plan-timeline__stepper" role="tablist">
            {stages.map((stage) => {
                const percent = progressPercent(stage);
                const range = formatRange(stage.start, stage.end);
                const isActive = stage.number === active;
                const isDone = stage.state === "done";
                // Тип приёма не задан — показываем нейтральное «Приём N».
                const title =
                    stage.title || t("plan.matrix.stage", { number: stage.number });

                return (
                    <button
                        key={stage.number}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        aria-label={t("plan.timeline.stageTitle", {
                            number: stage.number,
                            title,
                        })}
                        className={`plan-timeline__step is-${stage.state}${
                            isActive ? " is-active" : ""
                        }`}
                        onClick={() => onSelect?.(stage.number)}>
                        <span className="plan-timeline__step-top">
                            <span className="plan-timeline__step-num">
                                {isDone ? (
                                    <IoCheckmarkOutline
                                        aria-hidden="true"
                                        size={14}
                                    />
                                ) : (
                                    stage.number
                                )}
                            </span>
                            {stage.state === "current" ? (
                                <span className="plan-timeline__step-now">
                                    {t("plan.timeline.now")}
                                </span>
                            ) : null}
                        </span>

                        <span className="plan-timeline__step-title">
                            {title}
                        </span>

                        <span className="plan-timeline__step-hint">
                            {range ||
                                t("plan.timeline.noDate", {
                                    defaultValue: "Дата не задана",
                                })}
                        </span>

                        <span className="plan-timeline__step-line">
                            <span
                                className="plan-timeline__step-line-fill"
                                style={{ width: `${percent}%` }}
                            />
                        </span>
                    </button>
                );
            })}
        </div>
    );
}

export default PatientPlanTimelineStepper;
